import { createContext } from "react";
export var EnvContext = createContext(null);
export var AppContext = createContext(null);
export var LocaleContext = createContext("en");
export var FormContext = createContext(undefined);
export var WidgetContext = createContext(null);
export var SchemaContext = createContext(null);
export var SchemaExpressionContext = createContext(null);
export var CreateRootContext = createContext(null);
export var ArrayItemContext = createContext(null);
